<template>
  <Modal
      id="ChargingStationQuickEdit"
      width="60%"
      :open="visible"
      @cancel="visible = !visible"
      @ok="submit"
      :title="title"
      :destroyOnClose="true"
  >
    <Row align="middle" justify="center" class="modal">
      <Col span="18">
        <Row>
          <Col span="24">
            <Form
                ref="chargingStationForm"
                :model="form"
                layout="vertical"
                :rules="validateRules"
            >
              <Row justify="space-around">
                <Col span="10">
                  <FormItem :label="$t('meter.table.id_reg')" name="idReg">
                    <Select
                        v-model:value="form.idReg"
                        show-search
                        :placeholder="$t('public.pleaseSelect')"
                        style="width: 100%"
                        :options="options"
                        :filter-option="filterOption"
                        @change="handleChange"
                        allowClear
                    ></Select>
                  </FormItem>
                </Col>
                <Col span="10">
                  <FormItem label="&nbsp;" >
                    <Button type="primary" @click="addRegion()">
                      {{ $t("public.name.add") }}
                    </Button>
                  </FormItem>
                </Col>
                <Col span="10">
                  <FormItem :label="$t('chargingStation.table.id_met')" name="idMet">
                    <Select
                        v-model:value="form.idMet"
                        show-search
                        :placeholder="$t('public.pleaseSelect')"
                        style="width: 100%"
                        :options="metOptions"
                        :filter-option="filterOption"
                        allowClear
                    ></Select>
                  </FormItem>
                </Col>
                <Col span="10">
                  <FormItem label="&nbsp;" >
                    <Button type="primary" @click="addMeter()">
                      {{ $t("public.name.add") }}
                    </Button>
                  </FormItem>
                </Col>
                <Col span="10">
                  <FormItem :label="$t('chargingStation.table.charge_box_id')" name="chargeBoxId">
                    <Input :placeholder="$t('chargingStation.validate.charge_box_id')"
                           v-model:value="form.chargeBoxId">
                    </Input>
                  </FormItem>
                </Col>

                <Col span="10">
                  <FormItem :label="$t('chargingStation.table.charger_type')" name="chargerType">
                    <Select
                        v-model:value="form.chargerType"
                        :placeholder="$t('chargingStation.validate.charger_type')"
                        :options="chargerTypeList"
                        :dropdownStyle="{ zIndex: 9999999950 }"
                    >
                    </Select>
                  </FormItem>
                </Col>
                <Col span="10">
                  <FormItem :label="$t('chargingStation.table.name')" name="name">
                    <Input :placeholder="$t('chargingStation.validate.name')"
                           v-model:value="form.name">
                    </Input>
                  </FormItem>
                </Col>

<!--                <Col span="10">-->
<!--                  <FormItem :label="$t('chargingStation.table.enable')" name="enable">-->
<!--                    <Select-->
<!--                        disabled-->
<!--                        v-model:value="form.enable"-->
<!--                        :placeholder="$t('chargingStation.validate.enable')"-->
<!--                        :options="booleanList"-->
<!--                        :dropdownStyle="{ zIndex: 9999999950 }"-->
<!--                    >-->
<!--                    </Select>-->
<!--                  </FormItem>-->
<!--                </Col>-->
                <Col span="10">
                  <FormItem :label="$t('connector.table.power')" name="power">
                    <InputNumber
                        style="width: 100%"
                        v-model:value="form.power"
                        :placeholder="$t('connector.validate.required.power')"
                        :step="1"
                    />
                  </FormItem>
                </Col>

                <Col span="10">
                  <FormItem :label="$t('chargingStation.table.maxCurrent')" name="maxCurrent">
                    <InputNumber :placeholder="$t('chargingStation.validate.maxCurrent')" style="width: 100%" v-model:value="form.maxCurrent"></InputNumber>
                  </FormItem>
                </Col>

                <Col span="10">
                  <FormItem :label="$t('chargingStation.table.minCurrent')" name="minCurrent">
                    <InputNumber :placeholder="$t('chargingStation.validate.minCurrent')" style="width: 100%" v-model:value="form.minCurrent"></InputNumber>
                  </FormItem>
                </Col>

                <Col span="10">
                  <FormItem name="postpaid">

                    <template #label>
                      <div class="label-container">
                        <span>{{$t('region.table.postpaid')}}</span>
                        <Tooltip placement="top" :title="$t('chargingStation.tooltip.postpaid')" autoAdjustOverflow>
                          <question-circle-outlined class="label-icon"/>
                        </Tooltip>
                      </div>
                    </template>

                    <Select v-model:value="form.postpaid" :placeholder="$t('public.pleaseSelect')" :dropdownStyle="{zIndex: 9999999950}">
                      <SelectOption :value="0">{{ $t('public.isTrue.0') }}</SelectOption>
                      <SelectOption :value="1">{{ $t('public.isTrue.1') }}</SelectOption>
                      <SelectOption :value="2">{{ $t('chargingStation.billingMethodType.4') }}</SelectOption>
                    </Select>
                  </FormItem>
                </Col>

                <Col span="10">
                  <FormItem name="billingMethod">

                    <template #label>
                      <div class="label-container">
                        <span>{{$t('region.table.billingMethod')}}</span>
                        <Tooltip placement="top" :title="$t('chargingStation.tooltip.billingMethod')" autoAdjustOverflow>
                          <question-circle-outlined class="label-icon"/>
                        </Tooltip>
                      </div>
                    </template>

                    <Select v-model:value="form.billingMethod" :placeholder="$t('region.validate.billingMethod')" :dropdownStyle="{zIndex: 9999999950}">
                      <SelectOption :value="0">{{ $t('chargingStation.billingMethodType.0') }}</SelectOption>
                      <SelectOption :value="1">{{ $t('chargingStation.billingMethodType.1') }}</SelectOption>
                      <SelectOption :value="2">{{ $t('chargingStation.billingMethodType.2') }}</SelectOption>
                      <SelectOption :value="3">{{ $t('chargingStation.billingMethodType.3') }}</SelectOption>
                      <SelectOption :value="4">{{ $t('chargingStation.billingMethodType.4') }}</SelectOption>
                    </Select>
                  </FormItem>
                </Col>

                <Col span="10" v-if="isAdminPlus">
                  <FormItem :label="$t('chargingStation.table.monthly_fee')" name="monthlyFee" >
                    <InputNumber
                        v-model:value="form.monthlyFee"
                        :placeholder="$t('chargingStation.validate.monthly_fee')"
                        :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                        :min="0" :step="0.01"
                        style="width:100%"
                    />
                  </FormItem>
                </Col>

                <Col span="10">
                  <FormItem :label="$t('authority.table.sort')" name="sort">
                    <InputNumber
                        style="width: 100%"
                        v-model:value="form.sort"
                        :placeholder="$t('authority.validate.required.sort')"
                        :step="1"
                    />
                  </FormItem>
                </Col>

                <Col span="10">
                  <FormItem :label="$t('user.field.account')" name="idUse">
                    <Select
                        v-model:value="form.idUse"
                        show-search
                        :placeholder="$t('public.pleaseSelect')"
                        style="width: 100%"
                        :options="userOptions"
                        :filter-option="filterOption"
                        allowClear
                    ></Select>
                  </FormItem>
                </Col>

                <Col span="22">
                  <FormItem :label="$t('region.table.images')">
                    <UploadFile :urlList="fileList === undefined || fileList === null ? [] : fileList" :limit="3"
                                accept="image/*"
                                ref="upload_url"
                                @update_list="updateFileList"
                                @on_preview="onPreview"
                    />
                  </FormItem>
                </Col>
                <!--判断是否有子表，如果有则直接加入子表管理逻辑-->
                <!--遍历Table，找出子表-->
                <Col span="24" v-if="actionType==='edit'">
                  <Card size="small" :title="$t('connector.name.title')">
<!--                    <template #extra>-->
<!--                      <Button size="small" type="primary" block @click="addConnector">-->
<!--                        <PlusOutlined/>-->
<!--                        {{ $t("public.name.add") }}-->
<!--                      </Button>-->
<!--                    </template>-->
                    <Table size="small" :columns="connectorColumns" :data-source="form.connectorList" bordered :pagination="false">
                      <!-- 内容插槽-->
                      <template #bodyCell="{index, column, record}">
                        <template v-if="column.dataIndex === 'action'">
                          <div class="editable-row-operations">
                          <span>
                            <template v-if="actionType === 'edit'">
                              <a @click="editConnector(record)">{{ $t("public.name.edit") }}</a>&nbsp;
                            </template>
                            <Popconfirm :title="$t('public.name.are_you_sure_delete')" @confirm="removeConnector(index)">
                              <a>{{ $t("public.name.del") }}</a>
                            </Popconfirm>
                          </span>
                          </div>
                        </template>
                      </template>
                    </Table>
                  </Card>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Col>
      <Image
          v-if="imgIsShow"
          :style="{ display: 'none' }"
          :preview="{
            visible: imgIsShow,
            onVisibleChange: setVisible,
          }"
          :width="200"
          :height="200"
          :src="imgUrl"
          fallback="data:image/png;base64,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"
      ></Image>
    </Row>
  </Modal>
  <RegionEdit ref="refRegionEdit" @updateList="getRegionSelectList"></RegionEdit>
  <MeterEdit ref="refMeterEdit" @updateList="getMeterList" :options="options" :idReg="form.idReg"></MeterEdit>
  <ConnectorEdit ref="refConnectorEdit" @updateList="updateListConnector" ></ConnectorEdit>
</template>
<script>
export default {
  name: "ChargingStationQuickEdit",
}
</script>
<script setup>
import {
  Modal,
  Row,
  Col,
  Form,
  FormItem,
  Input,
  InputNumber,
  Image,
  Button,
  message,
  Select,
  SelectOption,
  Card,
  Table,
  Popconfirm,
  Tooltip
} from "ant-design-vue";
import {
  PlusOutlined,
  QuestionCircleOutlined
} from "@ant-design/icons-vue";
import {ChargingStationQuickAdd, ChargingStationQuickEdit} from "@/api/chargingStation";
import {MeterGetSelectListByidReg} from "@/api/meter"
import {RegionGetSelectList} from "@/api/region"
import RegionEdit from "@/views/Home/chargingStationSetting/regionManage/RegionEdit";
import MeterEdit from "@/views/Home/chargingStationSetting/meterManage/MeterEdit";
import ConnectorEdit from "@/views/Home/chargingStationSetting/connectorManage/ConnectorEdit";
import {ConnectorDelete, ConnectorList} from "@/api/connector"
import UploadFile from "@/components/Common/UploadFile"
import {useStore} from "vuex";
import {useI18n} from "vue-i18n";
import {reactive, ref, toRefs} from "vue";
import {UserGetSelectList, UserList} from "@/api/user";

const store = useStore()
const i18n = useI18n()
const emits = defineEmits(['updateList'])

const chargingStationForm = ref()
const refRegionEdit = ref()
const refMeterEdit = ref()
const refConnectorEdit = ref()

const isAdmin = store.getters.getIsAdmin
const isAdminPlus = store.getters.getIsSuperAdmin

let imgUrl = ref()
let imgIsShow = ref(false)
let value = ref()
let visible = ref(false)
let title =ref("")
let actionType =ref("")

const chargingPortTypeList = [
  {value: 0, label: 'Type 1'},
  {value: 1, label: 'Type 2'},
  {value: 2, label: 'CHAdeMO'},
  {value: 3, label: 'CCS 1'},
  {value: 4, label: 'CCS 2'},
]
const chargerTypeList = [
  {value: 1, label: i18n.t('public.chargerType.0')},
  {value: 2, label: i18n.t('public.chargerType.1')
}]
const booleanList = [{value: 0, label: i18n.t('public.isTrue.0')}, {value: 1, label: i18n.t('public.isTrue.1')}]
const statusList = [
  {value: 1, label: 'Available'},
  {value: 2, label: 'Preparing'},
  {value: 3,label: 'Charging'},
  {value: 4, label: 'SuspendedEVSE'},
  {value: 5, label: 'SuspendedEV'},
  {value: 6, label: 'Finishing'},
  {value: 7, label: 'Reserved'},
  {value: 8, label: 'Unavailable'},
  {value: 9, label: 'Faulted'},
  {value: 10, label: 'Disconnect'}]

const validateRules = {
  idReg: [
    {
      required: true,
      message: i18n.t("public.pleaseSelect"),
      trigger: "change",
      type: "number",
    },
  ],
  idChaPoi: [
    {
      required: true,
      message: i18n.t("chargingStation.validate.id_cha_poi"),
      trigger: "change",
      type: "number",
    },
  ],
  idMet: [
    {
      required: true,
      message: i18n.t("chargingStation.validate.id_met"),
      trigger: "change",
      type: "number",
    },
  ],
  chargeBoxId: [
    {
      required: true,
      message: i18n.t("chargingStation.validate.charge_box_id"),
      trigger: "change",
    },
  ],
  lastHeartbeatTime: [
    {
      required: true,
      message: i18n.t("chargingStation.validate.last_heartbeat_time"),
      trigger: "change",
    },
  ],
  monthlyFee: [
    {
      required: false,
      message: i18n.t("chargingStation.validate.monthly_fee"),
      trigger: "change",
      type: "number",
    },
  ],
  chargerType: [
    {
      required: true,
      message: i18n.t("chargingStation.validate.charger_type"),
      trigger: "change",
      type: "number",
    },
  ],
  postpaid: [
    {
      required: false,
      message: i18n.t("public.pleaseSelect"),
      trigger: "change",
      type: "number",
    },
  ],
  tenantKey: [
    {
      required: false,
      message: i18n.t("chargingStation.validate.tenant_key"),
      trigger: "change",
    },
  ],
  name: [
    {
      required: true,
      message: i18n.t("chargingStation.validate.name"),
      trigger: "change",
    },
  ],
  enable: [
    {
      required: false,
      message: i18n.t("chargingStation.validate.enable"),
      trigger: "change",
      type: "number",
    },
  ],
  power: [
    {
      required: true,
      message: i18n.t("connector.validate.required.power"),
      trigger: "power",
      type: "number",
    },
  ],
  minCurrent: [
    {
      required: true,
      message: i18n.t("chargingStation.validate.minCurrent"),
      trigger: "change",
      type: "number",
    },
  ],
  maxCurrent: [
    {
      required: true,
      message: i18n.t("chargingStation.validate.maxCurrent"),
      trigger: "change",
      type: "number",
    },
  ],
  billingMethod: [
    {
      required: false,
      message: i18n.t("region.validate.billingMethod"),
      trigger: "change",
      type: "number",
    },
  ],
}
const connectorColumns = [
  {title: i18n.t("connector.table.name"), dataIndex: "name", key: "name"},
  {title: i18n.t("connector.table.connector_id"), dataIndex: "connectorId", key: "connectorId"},
  {title: i18n.t("connector.table.power"), dataIndex: "power", key: "power"},
  {title: i18n.t("connector.table.type"), dataIndex: "type", key: "type", customRender: ({text}) =>{
      const obj = chargingPortTypeList.find(item=>item.value===text)
      return obj === undefined ? text :obj.label}
  },
  {
    title: i18n.t("public.table.action"),
    dataIndex: 'action',
  },
]

const data = reactive({
  options:[],
  metOptions: [],
  form: {},
  fileList: [],
  regionList: [],
  userOptions: []
})
const {options, metOptions, form, fileList, regionList, userOptions} = toRefs(data)

function addShow() {
  title.value = i18n.t("public.name.add");
  actionType.value = "add";
  _resetData();
  // 获取电表选择列表
  getMeterList()
  // 获取地址选择列表
  getRegionSelectList()
  // 获取用户列表
  getUserSelectList()

  visible.value = true;
}

async function editShow(obj) {
  title.value = i18n.t("public.name.add");
  actionType.value = "edit";
  _resetData();
  form.value = obj;
  // 获取电表选择列表
  getMeterList()
  // 获取地址选择列表
  getRegionSelectList()
  // 获取用户列表
  getUserSelectList()

  fileList.value = obj.imgList
  visible.value = true;

  // 获取端口列表
  const api = new ConnectorList()
  api.get({idChaPoi:obj.idChaPoi,page:1,limit:10}).then(res => {
    if (res.data !== undefined && res.data.data !== undefined && res.data.data.data !== undefined) {
      form.value.connectorList = res.data.data.data
    }
  })
}

function submit() {
  chargingStationForm.value?.validate().then(() => {
    let api;
    switch (actionType.value) {
      case "add":
        api = new ChargingStationQuickAdd();
        form.value.connectorListStr = JSON.stringify(form.value.connectorList)
        break;
      case "edit":
        api = new ChargingStationQuickEdit();
        break;
      default:
        return false;
    }
    if (fileList.value) {
      form.value.imagesListStr = JSON.stringify(fileList.value)
    }
    api.post(form.value).then(response => {
      if (0 === parseInt(response.data.code)) {
        message.success(i18n.t("succeedMsg.0"));
        emits("updateList", response.data.data);
        visible.value = false;
      } else {
        if(response.data.code !== undefined){message.error(i18n.t("errorMsg." + response.data.code));}
      }
    });
  }).catch(() => {});
}

function getMeterList() {
  if (form.value.idReg) {
    const api = new MeterGetSelectListByidReg();
    api.get({idReg: form.value.idReg}).then((response) => {
      if (0 === parseInt(response.data.code)) {
        metOptions.value = response.data.data;
      } else {
        if(response.data.code !== undefined){message.error(i18n.t("errorMsg." + response.data.code));}
      }
    });
  } else {
    metOptions.value = []
  }
}

function addRegion() {
  refRegionEdit.value?.addShow();
}

function addMeter() {
  refMeterEdit.value?.addShow(form.value.idReg, options);
}

function changeRegion() {
  form.value.idMet = "";
  getMeterList();
}

function addConnector() {
  // 校验表单
  chargingStationForm.value?.validate().then(() => {
    refConnectorEdit.value?.quickAddShow(form.value.idChaPoi);
  })
}

function editConnector(obj) {
  //因为后台没有返回这个关联id到该对象，所以当编辑时需要把关联id手动设定
  if (actionType.value === 'edit') {
    obj.idChaPoi = form.value.idChaPoi
  }
  refConnectorEdit.value?.editShow(obj);
}

function removeConnector(index) {
  if (actionType.value === 'add') {
    form.value.connectorList.splice(index, 1);
  } else {
    let connector = form.value.connectorList[index]
    const api = new ConnectorDelete();
    api.post({idCon: connector.idCon}).then((response) => {
      if (0 === parseInt(response.data.code)) {
        form.value.connectorList.splice(index, 1);
        message.success(i18n.t("succeedMsg.0"));
      } else {
        if(response.data.code !== undefined){message.error(i18n.t("errorMsg." + response.data.code));}
      }
    });
  }
}

function updateListConnector(obj) {
  if (actionType.value === 'add') {
    form.value.connectorList.push(obj);
  } else {
    let index = form.value.connectorList.findIndex(item => {
      return item.idCon === obj.idCon
    })
    //没有找到index，代表编辑时新增
    if (index === -1) {
      form.value.connectorList.push(obj);
    } else {
      form.value.connectorList[index] = obj
    }
  }
}

function updateFileList(f) {
  fileList.value = f
}

function onPreview(file) {
  // console.log("自定义文件预览 => ", file.url)
  imgUrl.value = file.url
  imgIsShow.value = true
}

function setVisible(value) {
  imgIsShow.value = value
}

function filterOption(input, option) {
  return option.label.indexOf(input) >= 0;
}

function getRegionSelectList() {
  const api = new RegionGetSelectList
  api.get().then(res => {
    if (0 === parseInt(res.data.code)) {
      options.value = res.data.data
    }
  })
}

function handleChange() {
  form.value.idMet = undefined
  if (form.value.idReg) {
    getMeterList()
  } else {
    metOptions.value = []
  }
}

function getUserSelectList() {
  const api = new UserGetSelectList()
  api.get().then(res => {
    if (0 === parseInt(res.data.code)) {
      userOptions.value = res.data.data
    }
  })
}

function _resetData() {
  form.value = {};
  fileList.value = [];
}
defineExpose({
  addShow,
  editShow
})
</script>

<style lang="less">
.modal {
  height: 65vh;
  overflow: auto;
}
.label-container {
  display: flex;
  align-items: center;
}

.label-icon {
  margin-left: 4px;
  color: #999;
}
</style>
